import React, { useState } from "react";
import {
  Button,
  Container,
  Form,
  FormGroup,
  InputGroup,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { MultiRangeSlider } from "./multiRangeSlider/MultiRangeSlider";
import { ParameterRange } from "../models/range.model";
import { ParameterClassification } from "../models/classification-model";

interface ScenarioType {
  [key: string]: number;
}

interface RangeType {
  [key: string]: ParameterRange;
}

interface Props {
  readonly classifications: ParameterClassification[];
  readonly target: ScenarioType;
  readonly setTarget: (t: ScenarioType) => void;
  readonly submit?: () => void;
  readonly ranges: RangeType;
  readonly markerValues: { [key: string]: ScenarioType };
}

export const TargetFormTabbed = ({
  classifications,
  target,
  setTarget,
  submit,
  ranges,
  markerValues,
}: Props) => {
  const [activeId, setActiveId] = useState(0);

  const toggle = (id: number) => {
    if (activeId !== id) {
      setActiveId(id);
    }
  };
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    submit?.();
  };

  const onChange = (min: number, _: number, id?: string) => {
    if (id === undefined || !(id in target)) return;
    const currentValue = target[id];
    if (currentValue === min) return;

    let newParams = { ...target, [id]: min };
    setTarget(newParams);
  };

  const sliders = (keys: string[]) =>
    keys.map((key) => {
      return (
        <InputGroup key={key}>
          <MultiRangeSlider
            id={key}
            {...ranges[key]}
            initialMin={target[key]}
            onChange={onChange}
            type={"single"}
            referenceMarkers={Object.entries(markerValues).map(
              ([markerType, values]) => ({
                value: values[key],
                key: markerType,
                unit: ranges[key].unit,
              })
            )}
          />
        </InputGroup>
      );
    });

  const navItems = classifications.map((v, i) => (
    <NavItem key={v.title}>
      <NavLink
        className={classnames({ active: activeId === i })}
        onClick={() => {
          toggle(i);
        }}
      >
        {v.title}
      </NavLink>
    </NavItem>
  ));

  const tabPanes = classifications.map((v, i) => (
    <TabPane tabId={i} key={v.id}>
      <FormGroup>{sliders(v.keys)}</FormGroup>
    </TabPane>
  ));

  return (
    <>
      <Container fluid>
        <Form onSubmit={handleSubmit}>
          <Nav tabs>{navItems}</Nav>
          <TabContent activeTab={activeId}>{tabPanes}</TabContent>
          {submit && (
            <Button type="submit" color="primary">
              Continue
            </Button>
          )}
        </Form>
      </Container>
    </>
  );
};
